/**
 * DADDL modal overlay — used by snippets/daddl-overlay.liquid.
 * Toggle the `open` attribute, or call element.open() / element.close().
 */
class DaddlOverlay extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-daddl-overlay-dialog]');
    this.onKey = (event) => {
      if (event.key === 'Escape' && this.hasAttribute('open')) {
        event.preventDefault();
        this.close();
      } else if (event.key === 'Tab' && this.hasAttribute('open')) {
        this.trapFocus(event);
      }
    };
    this.querySelectorAll('[data-daddl-overlay-dismiss]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });
    if (this.hasAttribute('open')) this.lock();
  }

  disconnectedCallback() {
    this.unlock();
  }

  static get observedAttributes() {
    return ['open'];
  }

  attributeChangedCallback(name, prev, next) {
    if (name !== 'open' || prev === next) return;
    if (next !== null) this.lock();
    else this.unlock();
  }

  open() {
    this._returnFocus = document.activeElement;
    this.setAttribute('open', '');
    const focusable = this.focusables()[0];
    focusable?.focus();
  }

  close() {
    if (!this.hasAttribute('open')) return;
    this.removeAttribute('open');
    this.dispatchEvent(new CustomEvent('daddl-overlay:close', { bubbles: true }));
    if (this._returnFocus && typeof this._returnFocus.focus === 'function') {
      this._returnFocus.focus();
    }
  }

  focusables() {
    return Array.from(
      this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter((el) => !el.hasAttribute('disabled') && el.offsetParent !== null);
  }

  trapFocus(event) {
    const nodes = this.focusables();
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  lock() {
    document.addEventListener('keydown', this.onKey);
    document.body.classList.add('daddl-overlay-open');
  }

  unlock() {
    document.removeEventListener('keydown', this.onKey);
    if (!document.querySelector('daddl-overlay[open]')) {
      document.body.classList.remove('daddl-overlay-open');
    }
  }
}

if (!customElements.get('daddl-overlay')) {
  customElements.define('daddl-overlay', DaddlOverlay);
}
